import styled, { css } from 'styled-components';

export const Content = styled.div`
  text-align: right;
  padding: 20px;
`;

export const Button = styled.button`
  border: 0;
  background: white;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 14px;
  margin-left: 12px;
  font-weight: bold;
  color: #ffffff;
  padding: 10px 21px;
  border-radius: 21px;
  transition: 0.2s all ease-in;
  color: var(--cp-accent, #3ea5ff);
  &:hover {
    background: #eee;
  }
  ${(props) =>
    (props.theme.theme === 'dark' || props.theme.ui === 'v2') &&
    css`
      background: var(--cp-surface);
      color: var(--cp-text);
      &:hover {
        background: var(--cp-surface-hover);
      }
    `}
`;

export const PrimaryButton = styled(Button)`
  background: var(--cp-accent, #3ea5ff);
  color: #fff;
  &:hover {
    background: #2e95ef;
  }
`;
